<template>
  <div id="NewTestView" class="new-test-view">
    <Header></Header>
    <b-container fluid>
      <b-row>
        <LeftNav></LeftNav>
        <b-col>
          <b-row>
            <TestsTabs isNew></TestsTabs>
          </b-row>
          <b-row>
            <b-col class="new-test p-0">
              <b-form id="new-test-form" @submit.prevent="confirmationModal" class="new-test-form pl-3 pr-3 p-sm-4 pl-sm-5">

                <b-form-row>
                  <b-col sm="6">
                    <b-form-group id="new-test-name" label="Name of your test" labelFor="new-test-name-input" class="new-test-form-label">
                      <b-form-input id="new-test-name-input" v-model="test.name" name="new-test-name-input" :disabled="isLoading" required></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-form-row>

                <b-form-row>
                  <b-col sm="6">
                    <b-form-group id="new-test-country" label="Select a Country" labelFor="new-test-country-select" class="new-test-form-label">
                      <multiselect id="new-test-country-select" v-model="selectedCountry" :options="countries" label="name" track-by="id" :show-labels="false" :allow-empty="false" :disabled="isLoading"></multiselect>
                    </b-form-group>
                  </b-col>
                </b-form-row>

                <b-form-row>
                  <b-col sm="6">
                    <b-form-group id="new-test-breakout" label="Select a breakout" labelFor="new-test-breakout-select" class="new-test-form-label">
                      <multiselect id="new-test-breakout-select" v-model="selectedBreakout" :options="breakouts" label="name" track-by="id" :show-labels="false" :allow-empty="false" :disabled="isLoading"></multiselect>
                    </b-form-group>
                  </b-col>
                </b-form-row>

                <b-form-row>
                  <b-col sm="6">
                    <b-form-group id="new-test-carrier" label="Select a carrier" labelFor="new-test-carrier-select" class="new-test-form-label">
                      <multiselect id="new-test-carrier-select" v-model="selectedCarrier" :options="carriers" label="name" track-by="id" :show-labels="false" :allow-empty="false" :disabled="isLoading"></multiselect>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="3">
                    <b-form-group id="new-test-percentage" label="Add volume %" labelFor="new-test-percentage-select" class="new-test-form-label">
                      <b-form-input id="new-test-percentage-select" type="number" step="0.01" v-model="test.percentage" :disabled="isLoading"></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-form-row>

                <b-form-row>
                  <b-col cols="12" sm="6">
                    <b-form-group id="new-test-start-date" :label="utc" labelFor="new-test-start-date" class="new-test-form-label">
                      <flat-pickr id="new-test-start-date" v-model="test.start" :config="config" placeholder="Select date" class="datetimepicker" :disabled="isLoading"></flat-pickr>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6">
                    <b-form-group id="new-test-end-date" label="Test end date (UTC)" labelFor="new-test-end-date" class="new-test-form-label">
                      <flat-pickr id="new-test-end-date" name="new-test-end-date" v-model="test.end" :config="config" placeholder="Select date" class="datetimepicker" :disabled="isLoading"></flat-pickr>
                    </b-form-group>
                  </b-col>
                </b-form-row>

                <b-form-row>
                  <b-col sm="12">
                    <b-form-group>
                      <p-check class="p-icon p-smooth" color="info" v-model="test.sendNotification" :disabled="isLoading">
                        <i slot="extra" class="icon material-icons">done</i>
                        Send notification SMS to SNOC
                      </p-check>
                    </b-form-group>
                  </b-col>
                </b-form-row>

                <b-form-row class="submit">
                  <b-col cols="12" sm="12">
                    <b-button type="submit" size="lg" variant="primary" :disabled="isLoading">Execute</b-button>
                    <b-button size="lg" variant="outline-danger" @click="resetTest" class="float-right" :disabled="isLoading">Clear</b-button>
                  </b-col>
                </b-form-row>
              </b-form>
            </b-col>
          </b-row>
        </b-col>
        <CurrentSetup></CurrentSetup>
      </b-row>
    </b-container>
    <TestSummaryModal></TestSummaryModal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import LeftNav from '@/components/layout/LeftNav.vue'
import Header from '@/components/layout/Header.vue'
import TestsTabs from '@/components/TestsTabs.vue'
import CurrentSetup from '@/components/CurrentSetup.vue'
import TestSummaryModal from '@/components/TestSummaryModal.vue'
import flatPickr from 'vue-flatpickr-component'
import moment from 'moment'

export default {
  name: 'NewTest',
  components: {
    LeftNav,
    Header,
    TestsTabs,
    CurrentSetup,
    TestSummaryModal,
    flatPickr
  },
  created () {
    this.clock()
    this.loadCarriers()
    this.$store.dispatch('tests/startNewTest').then(() => {
      let newTest = this.$store.state.tests.newTest
      this.test = Object.assign({}, newTest)
      this.setSelectedFields()
    }).then(() => {
      this.loadCountries()
    })
  },
  computed: {
    ...mapGetters({
      countries: 'countries/countries',
      carriers: 'tests/carriers',
      breakouts: 'tests/breakouts',
      getCountryById: 'countries/getCountryById',
      getCarrierById: 'tests/getCarrierById',
      isLoading: 'loader/isLoading'
    })
  },
  mounted () {
    this.$root.$on('createTestSuccess', (name) => {
      this.resetTest()
      this.$toastr.s(name + ' created succesfully')
    })
    this.$root.$on('createTestError', (message) => {
      this.$toastr.e(message)
    })
  },
  methods: {
    ...mapActions({
      loadCountries: 'countries/loadCountries',
      loadCarriers: 'tests/loadCarriers',
      reset: 'tests/setEmptyTest',
      setCountryId: 'tests/setCountryId'
    }),
    resetTest () {
      this.$store.dispatch('tests/setEmptyTest')
      let newTest = this.$store.state.tests.newTest
      this.test = Object.assign({}, newTest)
      this.selectedBreakout = {}
      this.selectedCarrier = {}
    },
    confirmationModal () {
      this.$root.$emit('bv::show::modal', 'modal-center')
    },
    setSelectedFields () {
      this.selectedCountry = this.getCountryById(this.test.countryId)
      this.selectedCarrier = this.getCarrierById(this.test.carrierId)
      this.selectedBreakout = {name: this.test.breakout, id: this.test.breakout}
      this.test.start = new Date()
    },
    clock () {
      moment.suppressDeprecationWarnings = true
      var text = 'Test start date (UTC) '
      var self = this
      self.utc = text
      window.setInterval(function () {
        self.utc = text + moment(new Date()).utc().format('HH:mm:ss')
      }, 1000)
    }
  },
  watch: {
    test: {
      handler (newValue) {
        this.$store.dispatch('tests/setTest', newValue)
      },
      deep: true
    },
    selectedCountry: {
      handler (newValue) {
        if (newValue !== undefined) {
          if (this.test.countryId !== newValue.id) {
            this.test.breakout = null
            this.selectedBreakout = {}
          }
          this.setCountryId({ countryId: newValue.id })
          this.test.countryId = newValue.id
        }
      }
    },
    selectedBreakout: {
      handler (newValue) {
        if (newValue.id !== undefined) {
          this.test.breakout = newValue.id
        }
      }
    },
    selectedCarrier: {
      handler (newValue) {
        if (newValue.id !== undefined) {
          this.test.carrierId = newValue.id
        }
      }
    }
  },
  data () {
    return {
      test: {},
      selectedCountry: {},
      selectedBreakout: {},
      selectedCarrier: {},
      showTestSummaryModal: false,
      utc: null,
      // Get more form https://chmln.github.io/flatpickr/options/
      config: {
        wrap: true, // set wrap to true only when using 'input-group'
        altFormat: 'M d, Y, H:i',
        enableTime: true,
        altInput: true,
        dateFormat: 'Y-m-d\\TH:i:S\\Z', // Z represents ISO date format Y-m-mTH:i:S
        minDate: 'today',
        time_24hr: true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.new-test-form-label {
  font-size: 12px !important;
  color: #687178;
}

.has-error {
  color: #ff0000;
  input {
    border-color: #ff0000;
  }
}

.new-test-form {
  max-width: 750px;
}
.submit{
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/tests/NewTest.vue